class HHVariantPicker extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  connectedCallback() {
    this.getVariantData()
    const urlParams = new URLSearchParams(window.location.search)
    const variantId = urlParams.get('variant')

    if (variantId) {
      this.currentVariant = this.variantData.find(
        (variant) => variant.id === parseInt(variantId)
      )
    }

    if (!this.currentVariant && this.variantData.length > 0) {
      this.currentVariant = this.variantData[0]
    }

    this.updateURL()
    this.updateVariantInput()
    this.handleVariantFocus()
    this.updateVariantAvailability()
  }

  updateVariantAvailability() {
    const variantCounts = this.getAttribute('data-variant-counts').split(',')

    if (variantCounts.length > 0) {
      const selectedOptions = this.getAttribute('data-selected-options').split(
        ','
      )
      const colorVariants = this.querySelectorAll('.color-variant')
      const sizeVariants = this.querySelectorAll('.size-variant')

      colorVariants.forEach((element) => {
        element.classList.remove('variant-disable')
      })
      sizeVariants.forEach((element) => {
        element.classList.remove('variant-disable')
      })

      if (selectedOptions.length > 2) {
        const colorVariantIndex =
          this.colorVariantIndex ?? parseInt(selectedOptions[1])
        const optionCount = sizeVariants.length

        colorVariants.forEach((colorVariant, index) => {
          let colorVariantAvailable = false

          for (
            let idx = optionCount * index;
            idx < optionCount * (index + 1);
            idx++
          ) {
            colorVariantAvailable =
              parseInt(variantCounts[idx]) > 0 ? true : colorVariantAvailable
          }

          if (!colorVariantAvailable) {
            colorVariant.classList.add('variant-disable')
          }
        })

        sizeVariants.forEach((sizeVariant, index) => {
          if (
            parseInt(variantCounts[optionCount * colorVariantIndex + index]) <=
            0
          ) {
            sizeVariant.classList.add('variant-disable')
          }
        })
      } else {
        colorVariants.forEach((colorVariant, index) => {
          if (parseInt(variantCounts[index]) <= 0) {
            colorVariant.classList.add('variant-disable')
          }
        })

        sizeVariants.forEach((sizeVariant, index) => {
          if (parseInt(variantCounts[index]) <= 0) {
            sizeVariant.classList.add('variant-disable')
          }
        })
      }
    }
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()
    this.updateVariantAvailability()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.updateMobileSelector()
      this.renderProductInfo()
      this.dispatchVariantChangeEvent()
      this.toggleQuantityInput(this.currentVariant.available)
      this.activeColor = this.currentVariant.option2
    }

    if (event.target.name == 'Color') {
      const changedElement = this.querySelector(
        `label[for="${event.target.id}"]`
      )
      if (changedElement) {
        this.updateActiveData(changedElement)
      }
    }
  }

  resetSelectedOption() {
    if (this.activeColor && this.activeColor.length > 0) {
      document.getElementById('selectedOption').textContent = this.activeColor
    }
  }

  preventRadioFocus() {
    const radioInputs = this.querySelectorAll(
      '.variant-picker input[type="radio"]'
    )
    radioInputs.forEach((input) => {
      input.setAttribute('tabindex', '-1')
    })
  }

  dispatchVariantChangeEvent() {
    const variantChangeEvent = new CustomEvent('variantChanged', {
      detail: {
        variantId: this.currentVariant.id,
        color: this.currentVariant.option2,
        image: this.currentVariant.featured_media,
      },
      bubbles: true,
    })
    this.dispatchEvent(variantChangeEvent)
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    if (fieldsets && fieldsets.length) {
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find(
          (radio) => radio.checked
        ).value
      })
    } else {
      this.options = Array.from(
        this.querySelectorAll('select'),
        (select) => select.value
      )
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    )
    if (!newMedia) return
    const parent = newMedia.parentElement
    parent.prepend(newMedia)
    window.setTimeout(() => {
      parent.scroll(0, 0)
    })
  }

  updateURL() {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    )

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updateMobileSelector() {
    const selector = document.querySelector('.sticky-footer-select')
    if (!selector) return

    const option = selector.querySelector(
      `option[value="${this.currentVariant.id}"]`
    )
    if (option) {
      selector.value = option.value
      document.querySelector('.stock-status-sticky-footer--message').innerHTML =
        this.currentVariant.available ? 'In Stock' : 'Out of Stock'
      const btnAddToCart = document.querySelector(
        '.stock-status-sticky-footer--cta'
      )
      btnAddToCart.innerHTML = this.currentVariant.available
        ? 'Add to Cart'
        : 'Sold Out'
      btnAddToCart.disabled = !this.currentVariant.available
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id)
        const source = html.getElementById(id)

        if (source && destination) destination.innerHTML = source.innerHTML

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden')
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        )
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')

    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', true)
      if (text) addButton.textContent = text
    } else {
      addButton.removeAttribute('disabled')
      addButton.textContent = addButton.hasAttribute('add-to-cart-message')
        ? addButton.getAttribute('add-to-cart-message')
        : window.variantStrings.addToCart
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    if (addButton) {
      addButton.textContent = window.variantStrings.unavailable
    }
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('hidden')

    document.querySelectorAll('.product__info-quantity').forEach((element) => {
      element.classList.add('hidden')
    })
  }

  toggleQuantityInput(available = false) {
    document.querySelectorAll('.product__info-quantity').forEach((element) => {
      available
        ? element.classList.remove('hidden')
        : element.classList.add('hidden')
    })
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }

  updateSelectedOption(event) {
    let colorName = event.target.getAttribute('data-color-name')
    if (colorName && colorName.length > 0) {
      document.getElementById('selectedOption').textContent = colorName
    }
  }

  simulateRadioChange(event) {
    if (event.type === 'keydown' && event.key !== 'Enter') {
      return
    }

    if (event.target.hasAttribute('data-option-index')) {
      this.colorVariantIndex = parseInt(
        event.target.getAttribute('data-option-index')
      )
    }

    let colorValue = event.currentTarget.getAttribute('data-color-name')
    let optionIndex = event.currentTarget.getAttribute('data-option-index')

    if (colorValue && colorValue.length > 0 && optionIndex !== null) {
      const correspondingRadioInput = document.querySelector(
        `.variant-picker input[value="${colorValue}"]`
      )

      if (correspondingRadioInput) {
        correspondingRadioInput.click()
        const swatchElement =
          event.currentTarget.length > 1
            ? event.currentTarget
            : document.querySelector(
                `.label-swatch.color-variant[data-color-name="${colorValue}"]`
              )
        this.updateActiveData(swatchElement)
      }
    }
  }

  updateActiveData(newActiveElement) {
    const currentActiveElement = this.querySelector(
      "label.label-swatch.color-variant[data-active='true']"
    )
    if (currentActiveElement) {
      currentActiveElement.setAttribute('data-active', 'false')
    }

    newActiveElement.setAttribute('data-active', 'true')
  }

  hasElementFocus() {
    return Array.from(
      this.querySelectorAll('.label-swatch.color-variant')
    ).some((element) => element === document.activeElement)
  }

  resetSelectedOption() {
    setTimeout(() => {
      if (!this.hasElementFocus()) {
        const activeElement = this.querySelector(
          "label.label-swatch.color-variant[data-active='true']"
        )
        if (activeElement) {
          let colorName = activeElement.getAttribute('data-color-name')
          if (colorName && colorName.length > 0) {
            document.getElementById('selectedOption').textContent = colorName
          }
        }
      }
    }, 0)
  }

  handleVariantFocus() {
    document
      .querySelectorAll('.label-swatch.color-variant')
      .forEach((element) => {
        element.addEventListener(
          'mouseover',
          this.updateSelectedOption.bind(this)
        )
        element.addEventListener(
          'focusin',
          this.updateSelectedOption.bind(this)
        )
        element.addEventListener(
          'mouseout',
          this.resetSelectedOption.bind(this)
        )
        element.addEventListener(
          'focusout',
          this.resetSelectedOption.bind(this)
        )
        element.addEventListener('click', this.simulateRadioChange.bind(this))
        element.addEventListener('keydown', this.simulateRadioChange.bind(this))
      })

    document.querySelectorAll('label.size-variant').forEach((element) => {
      element.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          element.click()
          element.focus()
        }
      })
    })

    this.addEventListener('focusout', this.resetSelectedOption.bind(this))
    this.preventRadioFocus()
  }
}

customElements.define('hh-variant-picker', HHVariantPicker)
